import styled from 'styled-components'

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px, 32px, 24px, 32px;

  p {
    margin-bottom: 16px;
  }

  button {
    margin-top: 8px;
    padding: 12px;
  }
`
